var exports = {
  "kL": "x112a1f60--762b14--container",
  "iE": "x112a1f60--762b14--wrapper",
  "DD": "x112a1f60--762b14--title",
};

module.exports = exports;
